<template>
  <div :class="['cont-cardSimple', attrs?.bWidgetGrafica ? 'border' : 'strokebase', '']" v-bind="attrs" >
    <div :class="['pa-0', 'cont-titulo', 'mt-2' , !!attrs?.bWidgetGrafica ? 'text-center' : '']" v-if="!!sTitulo">
      <Titulo
        :sTitulo="sTitulo+''"
        :attrs="{
          class: [!!attrs?.bWidgetGrafica ? 'text-substitle-2' : 'text-left', 'font-weight-medium', 'ntitlesdark--text', 'text-ellipsis', 'd-block'],
          style: { color: '#003743' },
        }"
      />
    </div>
    <div class="text-left mt-2">
      <DataPrincipal
        :sIcono="sIcono"
        :sLabel="sLabel"
        :aData="aData"
        :attrs="attrs"
        v-if="aData[0].length > 0"
      />
    </div>
    <v-divider v-if="!attrs?.bWidgetGrafica "/>
    <div :class="['cont-info', !!attrs?.bWidgetGrafica ? 'mt-1' : 'mt-2']">
      <DataAdicional v-if="aData[0].length > 1" :aData="aData" />
    </div>
  </div>
</template>
<script>
import Titulo from "@/views/Licencias/utils/Titulo.vue";
import DataPrincipal from "@/views/Licencias/Widget/components/DataPrincipal.vue";
import DataAdicional from "@/views/Licencias/Widget/components/DataAdicional.vue";
export default {
  name: "widget-base",
  components: {
    Titulo,
    DataPrincipal,
    DataAdicional,
  },
  props: {
    sTitulo: {
      type: String,
    },
    sLabel: {
      type: String,
      default: () => "",
    },
    aData: {
      type: Array,
      default: () => [[]],
    },
    sIcono: {
      type: String,
      default: () => "",
    },
    attrs: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.cont-cardSimple {
  padding: 5px 20px;
  margin: 0px;
  .cont-titulo {
    width: 100%;
    font-size: 1.125rem;
    p {
      font-size: 1.2em;
      margin: 0px;
    }
  }
  .cont-info {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.border {
  border: 1px solid #EBEDF0;
  border-radius: 5px;
  padding: 2px 5px;
}
.strokebase {
  border-radius: 6px;
  border: 1px solid #dddcdc;
  height: 150px;
}
.d-block {
  display: block;
  @media screen and (max-width: 1280px) {
    font-size: 0.9rem;
  }
}
</style>